import React, { useState } from 'react'
import { Dialog } from 'components'
import { Button, Typography } from '@mui/material'
import { useApproveAndSendProceedingsMutation, successSnack } from 'features'
import { useDispatch } from 'react-redux'
import { assetsFormatter } from 'formatters'
import numeral from 'numeral'

export default function ApproveAndSendProceedingsDialog(_props) {
  const {
    togglerComponent: Component = { Button },
    children,
    togglerProps = {},
    proceedingsList = [],
    newStatus = 's',
    successCallback = null,
    errorCallback = null,
  } = _props

  const [open, setOpen] = useState(false)

  const dispatch = useDispatch()

  function openDialog(e) {
    e.stopPropagation()
    setOpen(true)
  }
  function closeDialog() {
    setOpen(false)
  }

  const [approveAndSend] = useApproveAndSendProceedingsMutation()

  const total = proceedingsList.reduce((acc, item) => {
    return acc + numeral(item?.totalamount).value() || 0
  }, 0)

  function handleSubmit() {
    /**
     * payload should be structured as follow:
     *
     *  {
     *    "ProceedingList": [
     *      {
     *        "proceedingid": 19,
     *        "proceedingname": "PruebaTotals",
     *        "updatedat": "2022-08-17",
     *        "state": "p",
     *        "able": true,
     *        "totalamount": "30.00",
     *        "totalstudents": "2.00"
     *      }
     *    ]
     *  }
     */
    let payload = {
      ProceedingList: _props.proceedingsList.map((proceeding) => ({
        ...proceeding,
        state: newStatus,
      })),
    }
    const mutation = approveAndSend(payload)
    mutation
      .then((response) => {
        if (response.data?.message === 'update') {
          dispatch(
            successSnack({
              message:
                proceedingsList.length === 1
                  ? `Lote autorizado`
                  : 'Lote autorizados',
            })
          )
          if (successCallback) successCallback()
          closeDialog()
        }
      })
      .catch((error) => {
        if (errorCallback) errorCallback()
      })
  }

  return (
    <>
      <Component onClick={openDialog} {...togglerProps}>
        {children}
      </Component>
      {open && (
        <Dialog
          open={open}
          handleClose={closeDialog}
          primaryButtonText="Si, autorizar" //Label of the primary button
          secondaryButtonText="Cancelar" // Label of the cancel button
          title={
            proceedingsList.length === 1
              ? 'Autorizar lote'
              : 'Autorizar ' + proceedingsList.length + ' lotes'
          } // 'Dialog title'
          message={`¿Estás seguro de autorizar ${
            proceedingsList.length === 1
              ? 'el lote ' + proceedingsList[0].proceedingname
              : proceedingsList.length + ' lotes'
          }?\nEste paso no se puede deshacer.`}
          onSubmit={handleSubmit} // Form submit action
        >
          <div className="inline-block w-auto p-4 rounded-md border-2 border-primary">
            <Typography variant="body1" className="">
              Total de activos:{' '}
              <Typography variant="h3" component="span">
                {assetsFormatter(total)}
              </Typography>
            </Typography>
          </div>
        </Dialog>
      )}
    </>
  )
}
